"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextMode = exports.SetTextMessage = void 0;
const ColorConverter_1 = require("../ColorConverter");
class SetTextMessage {
    constructor(value, mode = TextMode.stationary, scrollSpeedMs = 25, color = "#FFFFFF") {
        this.value = value !== null && value !== void 0 ? value : " ";
        this.mode = mode;
        this.scrollSpeedMs = scrollSpeedMs;
        this.color = ColorConverter_1.ColorConverter.forceRgb(color);
        if (scrollSpeedMs > 254) {
            throw new Error("You really don't want this to scroll this slow. Also, our binary format can't deal with your big numbers ;)");
        }
    }
}
exports.SetTextMessage = SetTextMessage;
var TextMode;
(function (TextMode) {
    TextMode[TextMode["stationary"] = 0] = "stationary";
    TextMode[TextMode["scrollFromRight"] = 1] = "scrollFromRight";
})(TextMode = exports.TextMode || (exports.TextMode = {}));
//# sourceMappingURL=SetTextMessage.js.map